import React from 'react';
import { Box } from '@heycater/design-system';
import { BoxProps } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';

import Customers from 'static_pages/foodProgram/Customers';
import { FoodProgramH2 } from 'static_pages/foodProgram/Utils';
import Container from 'system/components/Container';

const COMPANY_AMOUNT = 200;

const Companies = (props: BoxProps) => {
  const theme = useTheme();
  const { t } = useTranslation('food_program');

  return (
    <Box as="section" {...props}>
      <Box
        py={{ xs: 3, md: 6 }}
        textAlign="center"
        bgcolor={theme.palette.grey[100]}
      >
        <Container size={880} maxWidth={{ xs: 550, md: 'none' }}>
          <FoodProgramH2 mb={{ xs: 3, md: 4 }}>
            {t('companies.title', { amount: COMPANY_AMOUNT })}
          </FoodProgramH2>
        </Container>
        <Container size={880} maxWidth={{ xs: 650, md: 'none' }}>
          <Customers />
        </Container>
      </Box>
    </Box>
  );
};

export default Companies;
